import React from 'react'
import Select from 'meinian-package/src/baseComponent/select'

export default (props) => {
  return <Select
    {...props}
    data={[{ label: '我上传的', value: '1' }, { label: '团队共享', value: '0' }]}
    placeholder="不限"
  />
}
